import { ArrowUp2, IconProps } from "iconsax-react";

const ArrowUp = (props: IconProps) => (<ArrowUp2 size="16" {...props} />)

export default ArrowUp;
